export default "__VITE_ASSET__bc0a56f1__"